import axios, { AxiosError } from "axios";
import { UseRefreshToken } from "../hooks/useRefreshToken";
import {v4 as uuidv4} from 'uuid';

export function getTaxV2() {
  const token  = localStorage.getItem("barte-auth-token");
  const { sendRefreshToken } = UseRefreshToken();

  const apiTaxasV2 = axios.create({
    baseURL: process.env.REACT_APP_API_URL_TAX_V2,
  });

  if (token) {
    apiTaxasV2.interceptors.request.use((config: any) => {
      const newConfig = config;
      newConfig.headers.Authorization = `Bearer ${token}`;
      newConfig.headers.post['x-idempotency-key'] = uuidv4();
      return newConfig;
    });
  }

  apiTaxasV2.interceptors.response.use(
    (response) => {
      return Promise.resolve(response);
    },
    (error: AxiosError) => {
      if (error?.response?.status === 401) {
        sendRefreshToken();
      } else if (error?.response?.status === 403) {
        localStorage.removeItem("barte-auth-token");
        window.location.replace(process.env.REACT_APP_FRONT_URL + "login");
      }
      return Promise.reject(error);
    }
  );

  return apiTaxasV2;
}
